export enum OrderStatusType{
    NEW='NEW',
    ASSIGNED='ASSIGNED',
    READY_FOR_TAKE_OFF = 'READY_FOR_TAKE_OFF',
    EN_ROUTE = 'EN_ROUTE',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    ERROR = 'ERROR',
  }